import type { Organization, OrganizationMember } from '../types/api';

export function organizationByIdMap(organizations: Organization[]): Map<string, Organization> {
    return new Map(organizations.map((org) => [org.id, org]));
}

export function inlineOrganizationForMember(
    member: Pick<OrganizationMember, 'organizationId' | 'organization'>,
    orgById: Map<string, Organization>,
): Organization | undefined {
    return member.organization ?? orgById.get(member.organizationId);
}
